import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  APPS_CONTAINER: `${cleanedFilename(__filename)}-apps-container`,
};
